import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DocumentUploadLayoutRoutingModule } from './document-upload-layout-routing.module';
import { DocumentUploadComponent } from './document-upload/document-upload.component';
import { FlexLayoutModule } from '@angular/flex-layout';
import { ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { IconModule } from '@visurel/iconify-angular';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import {DocumentUploadLayoutComponent} from './document-upload-layout.component';
import {MatSelectModule} from '@angular/material/select';
import {MatRadioModule} from '@angular/material/radio';
import {MatOptionModule} from '@angular/material/core'; 
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@NgModule({
  declarations: [DocumentUploadComponent, DocumentUploadLayoutComponent],
  imports: [
    CommonModule,
    DocumentUploadLayoutRoutingModule,
    FlexLayoutModule,
    ReactiveFormsModule,
    MatInputModule,
    MatIconModule,
    MatSnackBarModule,
    IconModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
    MatButtonModule,
    MatCheckboxModule,
    MatSelectModule,
    MatOptionModule,
    MatRadioModule
  ]
})
export class DocumentUploadLayoutModule {
}
